<div class="grid  grid-cols-2 gap-8">
  <div>
    <h6 class="mb-8">{{ 'settings.account.accountInformation.title' | transloco }}</h6>
    <div class="flex flex-row justify-center">
        <div class="mt-4 mb-8 ml-5">
           <div class="flex flex-row justify-center"  *ngIf="uploadAndPreview">
             <div class="bg-base-200 h-36 w-36 rounded-full">
               <img
                 class="object-cover h-36 w-36 rounded-full"
                 [src]="
              accountForm.get('profilePic').value
                ? accountForm.get('profilePic').value
                : profilePlaceholderPath
            "
                 alt="" />
             </div>
           </div>
          <div class="flex justify-center mt-4 min-w-0">
            <button nz-button nzType="default" (click)="uploadAndPreview = false">
              {{ 'settings.account.accountInformation.changeImage' | transloco }}
            </button>
          </div>
          <div *ngIf="!uploadAndPreview">
            <ngx-dropzone [multiple]="false" (change)="onSelect($event)">
              <ngx-dropzone-label>{{ 'settings.account.accountInformation.profilePicture' | transloco }}</ngx-dropzone-label>
              <ngx-dropzone-preview
                *ngFor="let f of files"
                [removable]="true"
                (removed)="onRemove(f)">
                <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
              </ngx-dropzone-preview>
            </ngx-dropzone>
            <nz-alert class="mt-2" nzType="info" nzShowIcon [nzMessage]="'settings.account.accountInformation.recommendedImageSize' | transloco"></nz-alert>
          </div>
        </div>
        <form nz-form class='w-full' [formGroup]="accountForm">
          <nz-form-item class="flex">
            <nz-form-label class="w-1/4 md:w-[35%]" nzRequired nzFor="firstname"
              >{{ 'settings.account.accountInformation.firstName' | transloco }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="firstNameCheck">
              <input
                type="text"
                nz-input
                formControlName="firstname"
                [placeholder]="'settings.account.accountInformation.placeholders.firstName' | transloco" />
            </nz-form-control>
            <ng-template #firstNameCheck>
              <span *ngIf="accountFormErrors.firstname.required">
                {{ 'settings.account.accountInformation.errors.firstNameRequired' | transloco }}
              </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="flex">
            <nz-form-label class="w-1/4 md:w-[35%]" nzFor="lastname"
              >{{ 'settings.account.accountInformation.lastName' | transloco }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="lastNameCheck">
              <input
                type="text"
                nz-input
                formControlName="lastname"
                [placeholder]="'settings.account.accountInformation.placeholders.lastName' | transloco" />
            </nz-form-control>
            <ng-template #lastNameCheck></ng-template>
          </nz-form-item>
          <nz-form-item class="flex">
            <nz-form-label class="w-1/4 md:w-[35%]" nzRequired nzFor="email"
              >{{ 'settings.account.accountInformation.email' | transloco }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="emailCheck">
              <input
                nz-input
                formControlName="email"
                [placeholder]="'settings.account.accountInformation.placeholders.email' | transloco" />
            </nz-form-control>
            <ng-template #emailCheck>
              <span *ngIf="accountFormErrors.email.required">
                {{ 'settings.account.accountInformation.errors.emailRequired' | transloco }}
              </span>
              <span *ngIf="accountFormErrors.email.email">
                {{ 'settings.account.accountInformation.errors.emailInvalid' | transloco }}
              </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="flex">
            <nz-form-label class="w-1/4 md:w-[35%]" nzFor="mobile" nzRequired
              >{{ 'settings.account.accountInformation.contactNumber' | transloco }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="numberCheck">
              <nz-input-group [nzAddOnBefore]="selectBefore">
                <ng-template #selectBefore>
                  <nz-select
                    nzAllowClear
                    nzShowSearch
                    [nzPlaceHolder]="'settings.account.accountInformation.placeholders.code' | transloco"
                    formControlName="dialCode" style="width: 100px"
                    [nzDropdownStyle]="{ width: '250px' }">
                    <nz-option *ngFor="let data of this.countries"
                               [nzValue]="data.dialing_code"
                               nzCustomContent="true"
                               [nzLabel]="data.dialing_code + ' ' + data.name ">
                      <div class="flex">
                        <img [src]="data.image" width="20" height="20" alt=" couintry">
                        <span class="mx-2">{{data.name}}</span>
                        <span>{{data.dialing_code}}</span>
                      </div>
                    </nz-option>
                  </nz-select>
                </ng-template>
                <input
                  nz-input
                  formControlName="mobile"
                  [placeholder]="'settings.account.accountInformation.placeholders.contactNumber' | transloco"
                />
              </nz-input-group>
              <ng-template #numberCheck>
              <span *ngIf="accountFormErrors.mobile.required"
              >{{ 'settings.account.accountInformation.errors.contactNumberRequired' | transloco }}</span
              >
                <span *ngIf="accountFormErrors.mobile.pattern"
                >{{ 'settings.account.accountInformation.errors.contactNumberInvalid' | transloco }}</span
                >
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <div class="flex justify-end mb-4">
            <button
              nz-button
              nzType="primary"
              [disabled]="accountForm.invalid"
              (click)="updateAccount('information')">
              {{ 'settings.common.update' | transloco }}
            </button>
          </div>
        </form>
    </div>
    <div *ngIf="msg === 'information'" class="my-2">
      <nz-alert
        *ngIf="actionMessage.display && actionMessage.isAdd"
        class="mt-2"
        [nzType]="actionMessage.type"
        [nzMessage]="actionMessage.message"
        nzShowIcon
        nzCloseable></nz-alert>
    </div>
  </div>
  <div>
    <div class="max-w-xxl">
      <h6 class="mb-8">{{ 'settings.account.changePassword.title' | transloco }}</h6>
      <form nz-form [formGroup]="passwordChangeForm">

        <nz-form-item class="flex items-baseline">
          <nz-form-label class="w-2/5" nzRequired nzFor="currentPassword">
            {{ 'settings.account.changePassword.currentPasswordLabel' | transloco }}
          </nz-form-label>
          <nz-form-control class="w-3/5" [nzErrorTip]="currentPasswordCheck">
            <nz-input-group [nzSuffix]="currentPasswordSuffixTemplate">
              <input
                [type]="currentPasswordVisible ? 'password' : 'text'"
                nz-input
                id="currentPassword"
                [placeholder]="'settings.account.changePassword.placeholders.currentPassword' | transloco"
                formControlName="currentPassword" />
            </nz-input-group>
            <ng-template #currentPasswordSuffixTemplate>
              <i
                class="cursor-on"
                nz-icon
                [nzType]="currentPasswordVisible ? 'eye' : 'eye-invisible'"
                (click)="currentPasswordVisible = !currentPasswordVisible"></i>
            </ng-template>
          </nz-form-control>
          <ng-template #currentPasswordCheck>
            <span *ngIf="passwordChangeFormErrors.currentPassword.required">
              {{ 'settings.account.changePassword.errors.currentPasswordRequired' | transloco }}
            </span>
          </ng-template>
        </nz-form-item>

        <nz-form-item class="flex items-baseline">
          <nz-form-label class="w-2/5" nzRequired nzFor="newPassword">
            {{ 'settings.account.changePassword.newPasswordLabel' | transloco }}
          </nz-form-label>
          <nz-form-control class="w-3/5" [nzErrorTip]="newPasswordCheck">
            <nz-input-group [nzSuffix]="newPasswordSuffixTemplate">
              <input
                [type]="newPasswordVisible ? 'password' : 'text'"
                nz-input
                id="newPassword"
                [placeholder]="'settings.account.changePassword.placeholders.newPassword' | transloco"
                formControlName="newPassword" />
            </nz-input-group>
            <ng-template #newPasswordSuffixTemplate>
              <i
                class="cursor-on"
                nz-icon
                [nzType]="newPasswordVisible ? 'eye' : 'eye-invisible'"
                (click)="newPasswordVisible = !newPasswordVisible"></i>
            </ng-template>
          </nz-form-control>
          <ng-template #newPasswordCheck>
            <span *ngIf="passwordChangeFormErrors.newPassword.required">
              {{ 'settings.account.changePassword.errors.newPasswordRequired' | transloco }}
            </span>
            <span *ngIf="passwordChangeFormErrors.newPassword.pattern">
              {{ 'settings.account.changePassword.errors.passwordPattern' | transloco }}
            </span>
          </ng-template>
        </nz-form-item>

        <nz-form-item class="flex items-baseline">
          <nz-form-label class="w-2/5" nzRequired nzFor="confirmPassword">
            {{ 'settings.account.changePassword.confirmPasswordLabel' | transloco }}
          </nz-form-label>
          <nz-form-control class="w-3/5" [nzErrorTip]="confirmPasswordCheck">
            <nz-input-group [nzSuffix]="confirmPasswordSuffixTemplate">
              <input
                [type]="confirmPasswordVisible ? 'password' : 'text'"
                nz-input
                id="confirmPassword"
                [placeholder]="'settings.account.changePassword.placeholders.confirmPassword' | transloco"
                formControlName="confirmPassword" />
            </nz-input-group>
            <ng-template #confirmPasswordSuffixTemplate>
              <i
                class="cursor-on"
                nz-icon
                [nzType]="confirmPasswordVisible ? 'eye' : 'eye-invisible'"
                (click)="confirmPasswordVisible = !confirmPasswordVisible"></i>
            </ng-template>
          </nz-form-control>
          <ng-template #confirmPasswordCheck>
            <span *ngIf="passwordChangeFormErrors.confirmPassword.required">
              {{ 'settings.account.changePassword.errors.confirmPasswordRequired' | transloco }}
            </span>
            <span *ngIf="passwordChangeFormErrors.confirmPassword.error">
              {{ 'settings.account.changePassword.errors.passwordNotMatched' | transloco }}
            </span>
          </ng-template>
        </nz-form-item>

        <div class="flex justify-end mb-8">
          <button
            nz-button
            nzType="primary"
            [disabled]="passwordChangeForm.invalid"
            (click)="updatePassword('password')">
            {{ 'settings.account.changePassword.confirmButton' | transloco }}
          </button>
        </div>

        <div *ngIf="msg === 'password'">
          <nz-alert
            *ngIf="actionMessage.display && actionMessage.isAdd"
            class="mt-2"
            [nzType]="actionMessage.type"
            [nzMessage]="actionMessage.message"
            nzShowIcon
            nzCloseable></nz-alert>
        </div>

      </form>
    </div>
  </div>
</div>
